function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StepHeader from '../../step-header';
import StepWrapper from '../step-wrapper';
import store from '../../../stores/main';
import TonePlayer from './tone-player';
import ToneFeedback from './tone-feedback';
import globals from '../../../utils/globals';
import CircularProgress from './circular-progress-bar';
var START_DB_INDEX = 3;
var TONES_DATA = [{
  value: '500 Hz',
  sounds: [{
    label: '10dB',
    points: 1
  }, {
    label: '20dB',
    points: 2
  }, {
    label: '30dB',
    points: 3
  }, {
    label: '40dB',
    points: 4
  }, {
    label: '50dB',
    points: 5
  }, {
    label: '60dB',
    points: 6
  }, {
    label: '70dB',
    points: 7
  }]
}, {
  value: '1000 Hz',
  sounds: [{
    label: '10dB',
    points: 1
  }, {
    label: '20dB',
    points: 2
  }, {
    label: '30dB',
    points: 3
  }, {
    label: '40dB',
    points: 4
  }, {
    label: '50dB',
    points: 5
  }, {
    label: '60dB',
    points: 6
  }, {
    label: '70dB',
    points: 7
  }]
}, {
  value: '4000 Hz',
  sounds: [{
    label: '10dB',
    points: 1
  }, {
    label: '20dB',
    points: 2
  }, {
    label: '30dB',
    points: 3
  }, {
    label: '40dB',
    points: 4
  }, {
    label: '50dB',
    points: 5
  }, {
    label: '60dB',
    points: 6
  }, {
    label: '70dB',
    points: 7
  }]
}];
var ToneStep = /*#__PURE__*/function (_Component) {
  function ToneStep(props) {
    var _this;
    _classCallCheck(this, ToneStep);
    _this = _callSuper(this, ToneStep, [props]);
    _this.state = {
      currentHzIndex: 0,
      currentDBIndex: 3,
      accumulatedScore: 0,
      hasSignificantHearingLoss: false,
      soundIndex: 1
    };
    _this.currentSoundFile = _this.currentSoundFile.bind(_this);
    _this.tonePlayerClickHandler = _this.tonePlayerClickHandler.bind(_this);
    _this.toneDone = _this.toneDone.bind(_this);
    window.DGS.Event.getInstance().trigger('trackHearingTestNextStep', globals.STEP_TYPE_TONE_START);
    return _this;
  }
  _inherits(ToneStep, _Component);
  return _createClass(ToneStep, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.onToneChange(this.state.currentHzIndex + 1);
    }
  }, {
    key: "currentSoundFile",
    value: function currentSoundFile() {
      var currentHz = TONES_DATA[this.state.currentHzIndex].value.replace(/ /g, '');
      var currentDB = TONES_DATA[this.state.currentHzIndex].sounds[this.state.currentDBIndex].label.replace(/ /g, '');
      var key = "Tone".concat(currentHz).concat(currentDB);
      var soundFile = this.props.soundPaths[key];
      return soundFile;
    }

    /**
     * Handles user feedback on tone test. If tone is audible, play lower sound dB. If not,
     * play higher sound dB.
     * @param {boolean} userDidHear True if user indicated he heard the sound, false if not
     */
  }, {
    key: "tonePlayerClickHandler",
    value: function tonePlayerClickHandler(userDidHear) {
      var _this2 = this;
      var currentDBIndex = this.state.currentDBIndex;
      var numSounds = TONES_DATA[this.state.currentHzIndex].sounds.length;
      var nextDBIndex = userDidHear ? this.state.currentDBIndex - 1 : this.state.currentDBIndex + 1;
      var isLoudestTone = nextDBIndex === numSounds;
      var toneIsDone = nextDBIndex < 0 ||
      // we've played the quietest dB
      isLoudestTone ||
      // we've played the loudest dB
      userDidHear && currentDBIndex > START_DB_INDEX ||
      // we've played a louder dB and the user can hear the next sound
      !userDidHear && currentDBIndex < START_DB_INDEX; // we've played a quieter dB and the user can't hear the next sound

      if (toneIsDone) {
        // If user heard the quietest tone (index = 0), don't add points
        var userHeardQuietestTone = this.state.currentDBIndex === 0 && userDidHear;
        var _ref = userHeardQuietestTone ? 0 : TONES_DATA[this.state.currentHzIndex].sounds[this.state.currentDBIndex],
          points = _ref.points;
        // if the user didn't hear the loudest sound, set significant hearing loss:
        if (!userDidHear && isLoudestTone) {
          this.setState({
            hasSignificantHearingLoss: true
          }, function () {
            return _this2.toneDone(points);
          });
        } else {
          this.toneDone(points);
        }
      } else {
        this.setState({
          currentDBIndex: nextDBIndex,
          soundIndex: this.state.soundIndex + 1
        });
      }
    }

    /**
     * Adds score for current tone to state.accumulatedScore and either:
     * 1) plays the next tone if there is one, or
     * 2) calls props.onNextClick with the accumulated score
     */
  }, {
    key: "toneDone",
    value: function toneDone(points) {
      var _this3 = this;
      var accumulatedScore = this.state.accumulatedScore + points;
      var index = this.state.currentHzIndex;
      if (index < TONES_DATA.length - 1) {
        // go to next Hz
        this.setState({
          accumulatedScore: accumulatedScore,
          currentHzIndex: index + 1,
          currentDBIndex: START_DB_INDEX,
          soundIndex: 1
        });
      } else {
        // test is done, call onNextClick with points
        this.setState({
          accumulatedScore: accumulatedScore
        }, function () {
          return _this3.props.onNextClick({
            points: _this3.state.accumulatedScore,
            significantHearingLoss: _this3.state.hasSignificantHearingLoss
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var content = this.props.content;
      var _this$state = this.state,
        currentHzIndex = _this$state.currentHzIndex,
        currentDBIndex = _this$state.currentDBIndex,
        soundIndex = _this$state.soundIndex;
      var soundFile = this.currentSoundFile();
      var heading = content.Heading.replace('{Hz}', TONES_DATA[currentHzIndex].value).replace('{dB}', TONES_DATA[currentHzIndex].sounds[currentDBIndex].label);
      var yesButtonLabel = content.ResponseOptions.find(function (option) {
        return option.TriggerPoints === true;
      }).Label;
      var noButtonLabel = content.ResponseOptions.find(function (option) {
        return option.TriggerPoints === false;
      }).Label;
      var HzTypesAmount = TONES_DATA.length;
      var percentage = Math.floor(currentHzIndex / HzTypesAmount * 100 + (soundIndex - 1) / (HzTypesAmount * (TONES_DATA[currentHzIndex].sounds.length - START_DB_INDEX)) * 100);
      return /*#__PURE__*/React.createElement(StepWrapper, {
        backgroundImage: content.BackgroundImage,
        stepClassNames: "step--tone"
      }, /*#__PURE__*/React.createElement("div", {
        className: "step__text"
      }, /*#__PURE__*/React.createElement(StepHeader, {
        icon: content.StepHeaderIcon,
        header: content.StepHeaderTitle
      }), /*#__PURE__*/React.createElement("div", {
        className: "tone-progress"
      }, /*#__PURE__*/React.createElement(CircularProgress, {
        sqSize: 60,
        strokeWidth: 10,
        percentage: percentage,
        showPercentage: true
      })), /*#__PURE__*/React.createElement("p", {
        className: "step__body"
      }, content.Body), /*#__PURE__*/React.createElement("h1", {
        className: "step__title"
      }, heading), /*#__PURE__*/React.createElement(TonePlayer, {
        soundFile: soundFile,
        volume: store.baseVolume,
        key: soundFile
      })), /*#__PURE__*/React.createElement("div", {
        className: "step__buttons"
      }, /*#__PURE__*/React.createElement(ToneFeedback
      // soundFile={soundFile}
      , {
        onYesClick: function onYesClick() {
          return _this4.tonePlayerClickHandler(true);
        },
        onNoClick: function onNoClick() {
          return _this4.tonePlayerClickHandler(false);
        },
        yesButtonLabel: yesButtonLabel,
        noButtonLabel: noButtonLabel
        // volume={store.baseVolume}
      })));
    }
  }]);
}(Component);
ToneStep.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onToneChange: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  soundPaths: PropTypes.object.isRequired
};
export default ToneStep;